module.exports = "<div class=\"dropdown__button js-button-region\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/dropdown/templates/dropdown.hbs
// module id = 651
// module chunks = 0